/**
 * 모바일 관리자 — 문자접수(뱅킹SMS).
 *
 * 앱이 단말에서 받아 올린 은행 SMS 를 CS 가 폰에서 확인하고, 입금건을 회원 캐시로 충전한다.
 * 목록·충전은 데스크탑 정본(Admin\SmsRecvController@getList / @deposit)을 그대로 부른다
 * (/ma/ajax/sms-recv/*, routes/madmin.php) — 조회·계산 로직 중복 없음.
 *
 * 데스크탑(/adm/sms-recv)은 8컬럼 DataTables 라 폰 폭에서 문자 본문이 잘린다.
 * 여기서는 **문자 한 건 = 카드 한 장**으로 세로로 쌓고, 본문을 두 줄까지 그대로 보여준다.
 */
import Util from '../../Common/Util';

const LENGTH = 30;

/**
 * 은행 SMS 본문 파서 — 데스크탑(smsRecv.blade.php parseMessage)과 같은 규칙.
 * 국민은행(KB) 알림 형식만 읽는다. 다른 은행/형식이면 null → 원문 그대로 보여준다.
 */
const KB_RE = /\[KB\](\d{2}\/\d{2}\s+\d{2}:\d{2})\s+[0-9*]{6,}\s+(\S+)\s+(입금|출금)\s+([\d,]+)\s+잔액/;

// 예금주에서 걷어낼 꼬리말 — 데스크탑 removeList 와 같은 목록
const NAME_NOISE = ['환불', '회비선결제', '추가등록비'];

export default class SmsRecv {
    initialize() {
        this.$list    = $('#maSmsList');
        this.$more    = $('#maSmsMore');
        this.$moreBtn = $('#maSmsMoreBtn');
        this.$empty   = $('#maSmsEmpty');
        this.$loading = $('#maSmsLoading');
        this.$sum     = $('#maSmsSum');
        this.$chips   = $('#maSmsChips');

        this.state = { type: 1, start: 0, total: 0, loading: false };
        this.rows  = {};

        this.bind();
        this.bindDatePickers();
        this.reload();
    }

    bind() {
        // 서랍(전체메뉴)에서 들어오는 화면이라 하단탭에 제자리가 없다 → 헤더 ← 로 되돌린다
        $('#maSmsBack').on('click', () => {
            if (history.length > 1) history.back();
            else location.replace('/ma/orders');
        });

        this.$chips.on('click', '.ma-chip', (e) => {
            const $c = $(e.currentTarget);
            this.$chips.find('.ma-chip').removeClass('is-active');
            $c.addClass('is-active');
            this.state.type = +$c.data('type') || 1;
            this.reload();
        });

        $('#maSmsSearchBtn').on('click', () => this.reload());
        $('#maSmsKw').on('keydown', (e) => { if (e.key === 'Enter') this.reload(); });
        this.$moreBtn.on('click', () => this.fetchList());

        // 무한 스크롤 — 미지원 브라우저에서는 위 '더보기' 버튼이 그대로 폴백으로 남는다
        this._infinite = $j.Ui.InfiniteScroll.attach(this.$more[0], { onLoad: () => this.fetchList() });
        if (this._infinite) this.$more.addClass('is-auto');

        this.$list.on('click', '[data-act="deposit"]', (e) => {
            const row = this.rows[$(e.currentTarget).closest('.ma-sms-row').data('num')];
            if (row) this.depositModal(row);
        });
        // 처리된 건의 입금자 → 그 회원 상세(기사관리)로. 데스크탑의 캐시창 대신 폰에 있는 자리다
        this.$list.on('click', '[data-mem]', (e) => {
            const n = parseInt($(e.currentTarget).data('mem'), 10) || 0;
            if (n) location.replace(`/ma/members?open=${n}`);
        });
    }

    /** 기간칸 — 접수화면(Order.bindDatePickers)과 같은 mobiscroll 달력 */
    bindDatePickers() {
        const $d = $('#maSmsD1, #maSmsD2');
        if (typeof $d.mobiscroll !== 'function') {   // vendor 미로드 시 최소 동작 보장
            $d.prop('readonly', false).on('change', () => this.reload());
            return;
        }
        $d.mobiscroll().datepicker({
            controls: ['calendar'],
            dateFormat: 'YYYY-MM-DD',
            locale: mobiscroll.localeKo,
            themeVariant: 'light',
            buttons: [],
            onChange: () => this.reload(),
        });
    }

    params() {
        return {
            draw: 1,
            start: this.state.start,
            length: LENGTH,
            type: this.state.type,
            start_date: $('#maSmsD1').val() || '',
            end_date: $('#maSmsD2').val() || '',
            findUserKwd: ($('#maSmsKw').val() || '').trim(),
        };
    }

    reload() {
        this.state.start = 0;
        this.rows = {};
        this.$list.empty();
        this.$empty.prop('hidden', true);
        this.fetchList();
    }

    fetchList() {
        if (this.state.loading) return;
        this.state.loading = true;
        this.$loading.prop('hidden', false);
        this.$more.prop('hidden', true);

        $.post('/ma/ajax/sms-recv/list', this.params(), null, 'json')
            .done((res) => {
                this.state.total = res.recordsTotal || 0;
                this.$sum.html(`<b class="n">${this.num(this.state.total)}</b>건`);

                const rows = res.data || [];
                rows.forEach((r) => {
                    this.rows[r.num] = r;
                    this.$list.append(this.rowHtml(r));
                });
                this.state.start += rows.length;

                this.$empty.prop('hidden', this.state.total !== 0);
                // rows 가 0건이면 total 이 뭐라 하든 멈춘다 — 무한 스크롤은 사람이 멈춰주지 않아서
                // total 과 실제 행수가 어긋나면 같은 요청을 끝없이 반복한다 (기사목록과 같은 가드)
                this.$more.prop('hidden', !(rows.length > 0 && this.state.start < this.state.total));
            })
            .fail((xhr) => this.toast(xhr.status === 401 ? '세션이 만료되었습니다' : '목록을 불러오지 못했습니다'))
            .always(() => {
                this.state.loading = false;
                this.$loading.prop('hidden', true);
            });
    }

    /**
     * 문자 카드 — 폰 한 화면 기준.
     *   1줄 수신시각 · 발신번호 · (처리완료 뱃지)
     *   2줄 문자 본문 (예금주·금액 강조)
     *   3줄 처리결과(입금자·처리자·처리시각) 또는 [처리] 버튼
     */
    rowHtml(r) {
        const info = this.parse(r.message);
        const done = !!r.manage_name;
        const isDeposit = +r.type === 1;

        const foot = isDeposit
            ? (done ? this.doneHtml(r) : this.todoHtml(info))
            : '';

        return `<div class="ma-sms-row${done ? ' is-done' : ''}" data-num="${r.num}">
            <div class="ma-sms-top">
                <span class="ma-sms-when">${this.esc(this.dt(r.created_at))}</span>
                <span class="ma-sms-phone">${this.esc(this.phone(r.phone))}</span>
                ${done ? '<span class="ma-sms-badge">처리완료</span>' : ''}
            </div>
            <div class="ma-sms-msg">${this.msgHtml(r.message, info)}</div>
            ${foot ? `<div class="ma-sms-foot">${foot}</div>` : ''}
        </div>`;
    }

    /** 처리된 입금건 — 누가 언제, 누구 캐시로 넣었나 */
    doneHtml(r) {
        const who = r.mb_no
            ? `<button type="button" class="ma-sms-mem" data-mem="${r.mb_no}">${this.esc(r.mem_name || '#' + r.mb_no)}</button>`
            : '';
        return `<span class="ma-sms-res">${who}<em>${this.esc(r.manage_name || '')}</em>`
            + `<i>${this.esc(this.dt(r.datetime))}</i></span>`;
    }

    /**
     * 미처리 입금건 — [처리] 버튼.
     *
     * 데스크탑은 KB 형식으로 읽힌 건에만 버튼을 냈다. 형식이 다른 은행 문자는 화면에 보이는데
     * 손댈 길이 없어 결국 PC 로 돌아가야 했으므로, 여기서는 **버튼을 항상 낸다** — 읽힌 건은
     * 금액이 채워져 열리고, 못 읽은 건은 CS 가 문자에 보이는 금액을 직접 넣는다.
     * (금액·회원은 어차피 모달에서 확인·수정하는 값이고, 서버 검증은 정본이 그대로 한다)
     */
    todoHtml(info) {
        const price = info ? info.price : 0;
        return `<button type="button" class="ma-sms-btn" data-act="deposit">`
            + (price ? `${this.num(price)}원 처리` : '처리') + '</button>';
    }

    /**
     * 본문 강조 — 거래시각(갈색) · 예금주(초록) · 금액(입금 파랑 / 출금 빨강).
     * 데스크탑 highlightBankSMS 와 같은 규칙이되, 원문을 먼저 이스케이프해서 넣는다.
     */
    msgHtml(message, info) {
        // 원문은 줄바꿈이 많다(발신머리·계좌·이름·금액·잔액이 각 줄). HTML 에서는 공백으로 접혀
        // 한 문단으로 읽히는데, 좁은 카드에서는 그편이 오히려 낫다.
        // '[Web발신]' 은 어느 문자에나 붙는 머리라 폰에서는 자리만 먹는다 → 걷어낸다.
        let s = this.esc(String(message || '').replace(/^\s*\[Web발신\]\s*/, ''));
        if (!info) return s;

        s = s.replace(/잔액.*$/, '');   // 잔액 뒤는 폰에서 자리만 먹는다
        const color = info.type === '출금' ? 'out' : 'in';
        const wrap = (v, cls) => `<span class="ma-sms-hl ${cls}">${v}</span>`;

        // 치환값은 콜백으로 넘긴다 — 문자열로 넘기면 '$&' 같은 패턴이 살아난다
        const hit = (needle, cls) => {
            if (!needle) return;
            const t = this.esc(needle);
            s = s.replace(t, () => wrap(t, cls));
        };
        hit(info.time, 'time');
        hit(info.rawWho, 'who');
        hit(info.rawPrice, color);
        return s;
    }

    /**
     * 문자 본문 → {time, who, price, type}. 데스크탑 parseMessage 와 같은 규칙.
     * rawWho·rawPrice 는 본문에 있는 그대로(강조 치환용), who·price 는 정리된 값(모달용).
     */
    parse(message) {
        const m = String(message || '').match(KB_RE);
        if (!m) return null;

        let who = m[2];
        NAME_NOISE.forEach((w) => { who = who.split(w).join(''); });
        who = who.replace(/\s+/g, ' ').trim();

        return {
            time: m[1],
            rawWho: m[2],
            who,
            type: m[3],
            rawPrice: m[4],
            price: parseInt(m[4].replace(/,/g, ''), 10) || 0,
        };
    }

    /**
     * 캐시 충전 — 입금자명을 보고 회원을 골라 금액을 넣는다.
     * 서버는 데스크탑 정본(Admin\SmsRecvController@deposit → SmsRecvService::creditDeposit) 그대로.
     */
    depositModal(row) {
        const info = this.parse(row.message);
        const price = info ? info.price : 0;
        const who = info ? info.who : '';

        const m = this.M.modal({
            title: '캐시 충전', okLabel: '충전',
            bodyHtml: `<label class="ma-mdl-lb">입금자</label>
                <div class="ma-mdl-in is-ro">${this.esc(who || '(문자에서 읽지 못함)')}</div>
                <label class="ma-mdl-lb">회원</label>
                <input type="text" class="ma-mdl-in" id="maSmsMem" autocomplete="off" enterkeyhint="search"
                       value="${this.esc(who)}" placeholder="이름·회원번호">
                <div class="ma-ac" id="maSmsMemAc" hidden></div>
                <label class="ma-mdl-lb">금액</label>
                <input type="tel" class="ma-mdl-in num" id="maSmsPrice" autocomplete="off" data-amount-kor
                       value="${price ? this.num(price) : ''}" placeholder="금액">
                <p class="ma-mdl-help">이름을 치면 후보가 나옵니다. 고르면 <b>이재일#2831</b> 처럼 채워지고 <b>#뒤 번호</b>가 충전 대상입니다.
                충전은 되돌릴 수 없으니 입금자명과 금액을 문자와 맞춰 보세요.</p>`,
            onOk: (b, close) => {
                const mbNo = this.pickMemberNum(b.querySelector('#maSmsMem').value);
                const amount = parseInt((b.querySelector('#maSmsPrice').value || '').replace(/[^\d]/g, ''), 10) || 0;
                if (!mbNo) return this.toast('목록에서 회원을 고르거나 회원번호를 입력하세요');
                if (!amount) return this.toast('금액을 입력하세요');
                this.deposit(row.num, amount, mbNo, close);
            },
        });

        // 회원칸은 입금자명으로 채워 열고 후보를 미리 띄운다 — CS 가 문자를 보며 다시 치지 않게.
        // 이름만 든 상태는 사람을 특정하지 못하므로(pickMemberNum → 0) 반드시 후보에서 골라야 한다.
        const $mem = m.bodyEl.querySelector('#maSmsMem');
        this.bindMemberAc($mem, m.bodyEl.querySelector('#maSmsMemAc'));
        if (($mem.value || '').trim().length >= 2) $mem.dispatchEvent(new Event('input'));
        // 금액칸은 치는 대로 천단위를 붙인다 — 0 하나 더 넣는 사고가 제일 잦다
        const $p = m.bodyEl.querySelector('#maSmsPrice');
        $p.addEventListener('input', () => {
            const n = parseInt(($p.value || '').replace(/[^\d]/g, ''), 10) || 0;
            $p.value = n ? this.num(n) : '';
        });
    }

    deposit(num, price, mbNo, close) {
        $.post('/ma/ajax/sms-recv/deposit', { num, price, mb_no: mbNo }, null, 'json')
            .done((r) => {
                if (r && r.result === false) return this.toast(r.message || '충전하지 못했습니다');
                close && close();
                this.toast('캐시 충전이 완료되었습니다');
                this.reload();
            })
            .fail((xhr) => this.toast(xhr.status === 401 ? '세션이 만료되었습니다' : '충전하지 못했습니다'));
    }

    /**
     * 회원(소유자) 자동완성 — 접수 홀드모달(Order.bindMemberAc)과 같은 정본·같은 규격.
     * 목록은 띄우지 않고 인풋 아래로 밀어내며 그린다(모달 본문이 overflow:auto 라 띄우면 잘린다).
     */
    bindMemberAc($in, $box) {
        if (!$in || !$box) return;
        const draw = (list) => {
            if (!list.length) { $box.hidden = true; $box.innerHTML = ''; return; }
            $box.innerHTML = list.slice(0, 20).map((r) => `
                <button type="button" class="ma-ac-item" data-num="${r.num}" data-name="${this.esc(r.mem_name || '')}">
                    <span class="n">${this.esc(r.mem_name || '-')}<em>#${r.num}</em></span>
                    <span class="p">${this.esc(r.mem_phone || '')}</span>
                </button>`).join('');
            $box.hidden = false;
            $box.querySelectorAll('.ma-ac-item').forEach((b) => {
                b.onclick = () => {
                    $in.value = `${b.dataset.name}#${b.dataset.num}`;
                    $box.hidden = true; $box.innerHTML = '';
                };
            });
        };

        const run = Util.debounce(() => {
            const kwd = ($in.value || '').trim();
            if (kwd.length < 2 || /#\d+$/.test(kwd)) { draw([]); return; }
            $.getJSON('/ma/ajax/members/autocomplete', { kwd })
                .done((list) => draw(Array.isArray(list) ? list : []))
                .fail(() => draw([]));
        }, 250);

        $in.addEventListener('input', run);
    }

    /**
     * 검색칸 텍스트 → 회원번호. **보이는 텍스트가 곧 기준이다** (hidden·data-value 금지 규약).
     *   '이재일#2831' → 2831   ·   '2831' → 2831   ·   '이재일' → 0(사람을 특정 못함)
     */
    pickMemberNum(v) {
        const t = String(v == null ? '' : v).trim();
        const m = t.match(/#(\d+)$/);
        if (m) return parseInt(m[1], 10) || 0;
        return /^\d+$/.test(t) ? (parseInt(t, 10) || 0) : 0;
    }

    get M() { return $j.Sites.MobileAdmin; }

    toast(msg) { if ($j.Ui && $j.Ui.Toast) $j.Ui.Toast.show(msg); }

    /** 'YYYY-MM-DD HH:MM:SS' → 'MM-DD HH:MM' (올해 것만 보므로 연도는 접는다) */
    dt(v) { return String(v || '').slice(5, 16); }

    phone(v) {
        const t = String(v || '').replace(/[^\d]/g, '');
        if (t.length === 11) return t.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
        if (t.length === 10) return t.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
        if (t.length === 8)  return t.replace(/(\d{4})(\d{4})/, '$1-$2');
        return String(v || '');
    }

    num(v) { return (parseInt(String(v).replace(/[^\d-]/g, ''), 10) || 0).toLocaleString('ko-KR'); }

    esc(s) {
        return String(s == null ? '' : s)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
}
